var $5a66492c841a0b80$exports = {};
const $5a66492c841a0b80$var$apiKey = "AIzaSyDV2wGCrJoTd5wSq17EAcYffLW7cBuFqKc";
const $5a66492c841a0b80$var$PAGE_SIZE = 5;
let $5a66492c841a0b80$var$visibleCount = $5a66492c841a0b80$var$PAGE_SIZE;
let $5a66492c841a0b80$var$upcomingEvents = [];
async function $5a66492c841a0b80$var$gapiLoaded() {
    try {
        gapi.load("client", $5a66492c841a0b80$var$initClient);
    } catch (error) {
        console.error("Error loading gapi client:", error);
    }
}
function $5a66492c841a0b80$var$initClient() {
    gapi.client.init({
        apiKey: $5a66492c841a0b80$var$apiKey,
        discoveryDocs: [
            "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"
        ]
    }).then(function() {
        $5a66492c841a0b80$var$listUpcomingEvents();
    }).catch((error)=>{
        console.error("Error initializing gapi client", error);
    //Display Error to User.
    });
}
function $5a66492c841a0b80$var$pageFadeIn() {
    const contentWrapper = document.getElementById("page-top");
    // 4. Trigger the fade-in animation
    // (The 'loaded' class sets opacity to 1, and CSS transition handles the rest)
    contentWrapper.classList.remove("page-wrapper-hidden"); // Remove 'hidden'
    contentWrapper.classList.add("page-wrapper-loaded"); // Add 'loaded' to start the transition
}
function $5a66492c841a0b80$var$listUpcomingEvents() {
    gapi.client.calendar.events.list({
        calendarId: "fd92fcfd178bf2bd25d622b7630ed8dab481be20c4dd7d773a183976dcad52b2@group.calendar.google.com",
        timeMin: new Date().toISOString(),
        showDeleted: false,
        singleEvents: true,
        maxResults: 50,
        orderBy: "startTime"
    }).then(function(response) {
        $5a66492c841a0b80$var$upcomingEvents = response.result.items || [];
        $5a66492c841a0b80$var$visibleCount = $5a66492c841a0b80$var$PAGE_SIZE;
        $5a66492c841a0b80$var$displayFeaturedEvent($5a66492c841a0b80$var$upcomingEvents);
        $5a66492c841a0b80$var$displayEvents();
    }).catch(function(error) {
        console.error("Error fetching events:", error);
    //Display an error message to the webpage here.
    });
}
function $5a66492c841a0b80$var$createGoogleMapsLink(locationString) {
    if (!locationString) return ""; // Return an empty string if location is not provided
    // Encode the location string for URL parameters
    const encodedLocation = encodeURIComponent(locationString);
    // Construct the Google Maps URL
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
    return googleMapsUrl;
}
function $5a66492c841a0b80$var$displayEvents() {
    const calendarContainer = document.getElementById("gcal-container");
    calendarContainer.innerHTML = "";
    const events = $5a66492c841a0b80$var$upcomingEvents;
    const validEvents = events.filter((event)=>event.start && event.start.dateTime && event.location);
    if (validEvents.length === 0) {
        const noEvents = document.createElement("p");
        noEvents.textContent = "There are no upcoming events.";
        calendarContainer.appendChild(noEvents);
        return;
    }
    const eventsToShow = validEvents.slice(0, $5a66492c841a0b80$var$visibleCount);
    for (const event of eventsToShow){
        const eventRow = document.createElement("div");
        eventRow.classList.add("row", "performancesRow");
        calendarContainer.appendChild(eventRow);
        const gcalCol1 = document.createElement("div");
        gcalCol1.classList.add("col-lg-4", "col-md-4", "col-sm-12", "col-xs-12");
        eventRow.appendChild(gcalCol1);
        const gcalCol2 = document.createElement("div");
        gcalCol2.classList.add("col-lg-4", "col-md-4", "col-sm-12", "col-xs-12");
        eventRow.appendChild(gcalCol2);
        const gcalCol3 = document.createElement("div");
        gcalCol3.classList.add("col-lg-4", "col-md-4", "col-sm-12", "col-xs-12");
        eventRow.appendChild(gcalCol3);
        const startTime = new Date(event.start.dateTime);
        const startDate = startTime.toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
        const startTimeString = startTime.toLocaleTimeString(undefined, {
            hour: "numeric",
            minute: "numeric",
            hour12: true
        });
        const endTime = new Date(event.end.dateTime);
        const endTimeString = endTime.toLocaleTimeString(undefined, {
            hour: "numeric",
            minute: "numeric",
            hour12: true
        });
        const dateParagraph = document.createElement("p");
        dateParagraph.classList.add("performancesDate");
        dateParagraph.textContent = `${startDate}`;
        gcalCol1.appendChild(dateParagraph);
        const timeParagraph = document.createElement("p");
        timeParagraph.classList.add("performancesLoc2");
        timeParagraph.textContent = `${startTimeString} - ${endTimeString}`;
        gcalCol1.appendChild(timeParagraph);
        let location = event.location.split(",");
        let businessName = location[0].trim();
        let town = location[2].trim();
        let state = location[3].trim().split(/\s+/)[0].trim();
        let townName = state ? `${town}, ${state}` : town;
        let locationLink = $5a66492c841a0b80$var$createGoogleMapsLink(event.location);
        const townParEl = document.createElement("p");
        townParEl.classList.add("performancesLoc1");
        townParEl.textContent = townName;
        gcalCol1.appendChild(townParEl);
        const summaryParEl = document.createElement("p");
        summaryParEl.classList.add("performancesTitle1");
        const iconEl = document.createElement("i");
        iconEl.classList.add("fas", "fa-location-dot", "inline-icon");
        const businessParEl = document.createElement("p");
        businessParEl.classList.add("performancesLocHead", "inline-text");
        businessParEl.textContent = businessName;
        summaryParEl.textContent = event.summary;
        const descriptionDivEl = document.createElement("div");
        descriptionDivEl.innerHTML = event.description;
        descriptionDivEl.classList.add("performancesLoc2");
        gcalCol2.appendChild(summaryParEl);
        gcalCol2.appendChild(iconEl);
        gcalCol2.appendChild(businessParEl);
        gcalCol2.appendChild(descriptionDivEl);
        const locationButton = document.createElement("button");
        locationButton.classList.add("btn", "btn-default", "btn-lg", "btnAction", "mastheadButton");
        const buttonTextSpan = document.createElement("span");
        buttonTextSpan.textContent = "Directions";
        buttonTextSpan.classList.add("btnText");
        locationButton.appendChild(buttonTextSpan);
        locationButton.addEventListener("click", ()=>{
            window.open(locationLink, "_blank");
        });
        gcalCol3.appendChild(locationButton);
    }
    if (validEvents.length > $5a66492c841a0b80$var$visibleCount) {
        const showMoreWrapper = document.createElement("div");
        showMoreWrapper.classList.add("production-show-more-wrapper");
        const showMoreButton = document.createElement("button");
        showMoreButton.type = "button";
        showMoreButton.textContent = "Show more";
        showMoreButton.classList.add("production-show-more-button", "btn", "btn-default", "btn-lg", "btnAction", "productionButton");
        showMoreButton.addEventListener("click", ()=>{
            $5a66492c841a0b80$var$visibleCount += $5a66492c841a0b80$var$PAGE_SIZE;
            $5a66492c841a0b80$var$displayEvents();
        });
        showMoreWrapper.appendChild(showMoreButton);
        calendarContainer.appendChild(showMoreWrapper);
    }
}
async function $5a66492c841a0b80$var$displayFeaturedEvent(events) {
    const featuredCalendarContainer = document.getElementById("featured-gcal-container");
    featuredCalendarContainer.innerHTML = "";
    if (events.length === 0) {
        const noEvents = document.createElement("p");
        noEvents.textContent = "There are no upcoming events.";
        featuredCalendarContainer.appendChild(noEvents);
        return;
    }
    // Get the first event from the list
    const event = events[0];
    if (event.start && event.start.dateTime && event.location) {
        const eventRow0 = document.createElement("p");
        eventRow0.classList.add("row", "mastheadSmallPara");
        eventRow0.textContent = `Next performance:`;
        featuredCalendarContainer.appendChild(eventRow0);
        const eventRow1 = document.createElement("div");
        eventRow1.classList.add("row");
        featuredCalendarContainer.appendChild(eventRow1);
        const eventRow2 = document.createElement("div");
        eventRow2.classList.add("row");
        featuredCalendarContainer.appendChild(eventRow2);
        const eventRow3 = document.createElement("div");
        eventRow3.classList.add("row", "text-right");
        featuredCalendarContainer.appendChild(eventRow3);
        const mastheadTextContainer = document.createElement("div");
        mastheadTextContainer.classList.add("mastheadTextContainer");
        eventRow1.appendChild(mastheadTextContainer);
        const summaryParEl = document.createElement("p");
        summaryParEl.classList.add("mastheadText");
        mastheadTextContainer.appendChild(summaryParEl);
        let location = event.location.split(",");
        let businessName = location[0].trim();
        let town = location[2].trim();
        let state = location[3].trim().split(/\s+/)[0].trim();
        let townName = state ? `${town}, ${state}` : town;
        let locationLink = $5a66492c841a0b80$var$createGoogleMapsLink(event.location);
        const startTime = new Date(event.start.dateTime);
        const startDate = startTime.toLocaleDateString(undefined, {
            month: "short",
            day: "numeric"
        });
        const townParEl = document.createElement("p");
        townParEl.classList.add("mastheadPara");
        townParEl.textContent = `${townName} \u{2022} ${startDate}`;
        eventRow1.appendChild(townParEl);
        summaryParEl.textContent = event.summary;
        const locationButton = document.createElement("a");
        locationButton.href = "#gcalAnchor";
        locationButton.classList.add("btn", "btn-default", "btn-lg", "btnAction", "mastheadButton", "page-scroll");
        const buttonTextSpan = document.createElement("span");
        buttonTextSpan.textContent = "Details";
        buttonTextSpan.classList.add("btnText");
        locationButton.appendChild(buttonTextSpan);
        eventRow3.appendChild(locationButton);
        $5a66492c841a0b80$var$pageFadeIn();
    }
}
window.onload = $5a66492c841a0b80$var$gapiLoaded();


//# sourceMappingURL=repo.2a1d4f05.js.map
